(() => {
  const page = document.querySelector('[data-dsj-page]');
  if (!page) return;
  const disclosure = page.querySelector('[data-dsj-disclosure]');
  if (disclosure && window.matchMedia('(min-width: 701px)').matches) disclosure.open = true;
  page.querySelectorAll('a[href="#dsj-filters"]').forEach(link => {
    link.addEventListener('click', () => { if (disclosure) disclosure.open = true; });
  });
  const filters = page.querySelector('[data-dsj-filters]');
  filters?.addEventListener('submit', event => {
    event.preventDefault();
    const data = new FormData(filters);
    const tags = [data.get('character'), data.get('type')].filter(Boolean);
    const url = new URL(filters.dataset.collectionUrl, location.origin);
    if (tags.length) url.pathname += '/' + tags.map(encodeURIComponent).join('+');
    const sort = data.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);
    url.hash = 'dsj-catalog';
    location.assign(url.href);
  });
  page.querySelector('[data-dsj-sort]')?.addEventListener('change', event => event.target.form.requestSubmit());
})();
